import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

export const GenerationLimit = () => {
  const [s, setS] = useState(null);
  const load = () => api.adminGeneration().then(setS).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!s) return null;
  const save = async (n) => {
    try {
      await api.adminSetGeneration(n);
      toast.success(`Up to ${n} book${n > 1 ? "s" : ""} will be written at once`);
      load();
    } catch (e) {
      toast.error(apiError(e));
    }
  };
  return (
    <div className="rounded-2xl border border-gold-500/12 bg-navy-900/40 p-5 flex flex-wrap items-center gap-4" data-testid="admin-generation-limit">
      <div className="flex-1 min-w-[220px]">
        <p className="font-ui text-sm font-semibold text-slate-100">Books written at the same time</p>
        <p className="font-ui text-xs text-slate-500" data-testid="admin-generation-status">
          {s.running} writing now · {s.waiting} waiting in line
        </p>
      </div>
      <div className="flex gap-1">
        {[1, 2, 3].map((n) => (
          <button key={n} data-testid={`admin-generation-limit-${n}`} onClick={() => save(n)}
            className={`font-ui text-sm w-10 h-9 rounded-lg border transition-colors ${s.max_workers === n ? "bg-gold-400 text-stone-950 border-gold-400" : "border-gold-500/20 text-slate-300 hover:border-gold-400/60"}`}>
            {n}
          </button>
        ))}
      </div>
    </div>
  );
};
